import React, { Component, SyntheticEvent } from "react";
import { style, classes } from "typestyle";

type InputProps = {
  className?: string;
  label?: string;
  value?: string;
  type?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  error?: string | null;
};
type InputState = {
  isFocused: boolean;
};
export default class Input extends Component<InputProps, InputState> {
  state = {
    isFocused: false,
  };

  render(): JSX.Element {
    const { className, label, value, type, error } = this.props;
    const { isFocused } = this.state;
    const primaryColor = error && !isFocused ? "#DE3226" : "#079DF5";
    return (
      <div
        className={classes(
          style({
            padding: "20px 0",
            position: "relative",
          }),
          className,
        )}
      >
        {!!((isFocused || value) && label) && (
          <div
            className={style({
              fontSize: "12px",
              color: primaryColor,
              position: "absolute",
              top: "6px",
            })}
          >
            {label}
          </div>
        )}
        <input
          type={type || "text"}
          value={value || ""}
          placeholder={isFocused ? "" : label}
          onChange={this.onChange}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          className={style({
            border: "none",
            borderBottom: `${isFocused ? "2" : "1"}px solid ${primaryColor}`,
            marginBottom: isFocused ? "0" : "1px",
            padding: "8px 0",
            width: "100%",
            lineHeight: "24px",
            fontSize: "16px",
          })}
        />
        {error && (
          <div
            className={style({
              fontSize: "12px",
              color: "#DE3226",
              position: "absolute",
            })}
          >
            {error}
          </div>
        )}
      </div>
    );
  }

  onChange = (e: SyntheticEvent<HTMLInputElement>): void => {
    const { onChange } = this.props;
    if (!onChange) {
      return;
    }
    onChange(e.currentTarget.value);
  };

  onFocus = (): void => {
    this.setState({
      isFocused: true,
    });
  };

  onBlur = (): void => {
    this.setState({
      isFocused: false,
    });
  };
}
